import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';
export const userColumns = [
    {
        field: "name",
        headerName: "Name",
        width: 150,
    },

    {
        field: "ipdNo",
        headerName: "Ipd Number",
        width: 200,
    },
    {
        field: "gender",
        headerName: "Age/Gender",
        width: 100,
        renderCell: (params) => {
          return (
            <div className="cellWithImg">
              {
                params?.row?.gender === "1" ? <>{params?.row?.age}/<ManIcon style={{ color: "blue"}} /></>: 
                params?.row?.gender === "2" ? <>{params?.row?.age}/<WomanIcon style={{ color: "pink"}}/></> : "Others"
              }
              
            </div>
          );
        },
      },
   
    {
        field: "mobile",
        headerName: "Mobile",
        width: 150,
    },
    {
        field: "cardName",
        headerName: "Card Name",
        width: 150,
    },
    {
        field: "admissionDate",
        headerName: "Admission Date",
        width: 150,
    },
    {
        field: "cardHolderName",
        headerName: "Card Holder Name",
        width: 150,
    },
    {
        field: "amount",
        headerName: "Amount",
        width: 150,
    },
    {
        field: "insuranceName",
        headerName: "Insurance Name",
        width: 150,
    },
    {
        field: "packageName",
        headerName: "Package Name",
        width: 150,
    },
  

];